// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SimpleCRM Games — shared styles for the hub + individual games */

.games-hero {
    background: linear-gradient(135deg, #1F2937 0%, #111827 100%);
    color: #fff;
    border-radius: 14px;
}

.games-card {
    transition: transform 0.15s ease, box-shadow 0.15s ease;
    cursor: pointer;
    background: #fff;
    border: 1px solid #E5E7EB;
    border-radius: 12px;
}

.games-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}

.games-card-icon {
    height: 56px;
    width: 56px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    color: #fff;
    flex-shrink: 0;
}

/* Pulse for online dot */
@keyframes crm-pulse-dot {
    0%   { box-shadow: 0 0 0 0   rgba(16, 185, 129, 0.55); }
    70%  { box-shadow: 0 0 0 6px rgba(16, 185, 129, 0); }
    100% { box-shadow: 0 0 0 0   rgba(16, 185, 129, 0); }
}
.crm-online-dot {
    height: 8px;
    width: 8px;
    border-radius: 999px;
    background: #10B981;
    animation: crm-pulse-dot 2s infinite;
    flex-shrink: 0;
}

/* 2048 tiles */
.tile {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    font-weight: 700;
    -webkit-user-select: none;
            user-select: none;
    transition: transform 80ms;
}

.tile-0    { background: #E5E7EB; color: transparent; }
.tile-2    { background: #FDE68A; color: #78350F; }
.tile-4    { background: #FCD34D; color: #78350F; }
.tile-8    { background: #FB923C; color: #fff; }
.tile-16   { background: #F97316; color: #fff; }
.tile-32   { background: #EF4444; color: #fff; }
.tile-64   { background: #DC2626; color: #fff; }
.tile-128  { background: #FBBF24; color: #fff; font-size: 28px !important; }
.tile-256  { background: #F59E0B; color: #fff; font-size: 28px !important; }
.tile-512  { background: #D97706; color: #fff; font-size: 28px !important; }
.tile-1024 { background: #B45309; color: #fff; font-size: 22px !important; }
.tile-2048 { background: #92400E; color: #fff; font-size: 22px !important; box-shadow: 0 0 16px rgba(217, 119, 6, 0.6); }

/* Memory cards */
.memory-card {
    perspective: 1000px;
    aspect-ratio: 1;
    cursor: pointer;
}
.memory-card-inner {
    position: relative;
    width: 100%;
    height: 100%;
    transition: transform 0.5s;
    transform-style: preserve-3d;
}
.memory-card.flipped .memory-card-inner {
    transform: rotateY(180deg);
}
.memory-card-face {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
}
.memory-card-face.front {
    background: linear-gradient(135deg, #6366F1, #4F46E5);
    color: #fff;
}
.memory-card-face.back {
    background: #fff;
    border: 2px solid #E5E7EB;
    transform: rotateY(180deg);
}
.memory-card.matched .memory-card-face.back {
    background: #D1FAE5;
    border-color: #10B981;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Games.css"],"names":[],"mappings":"AAAA,mEAAmE;;AAEnE;IACI,6DAA6D;IAC7D,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,uDAAuD;IACvD,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,OAAO,8CAA8C,EAAE;IACvD,OAAO,2CAA2C,EAAE;IACpD,OAAO,2CAA2C,EAAE;AACxD;AACA;IACI,WAAW;IACX,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,oCAAoC;IACpC,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAiB;YAAjB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA,aAAa,mBAAmB,EAAE,kBAAkB,EAAE;AACtD,aAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,aAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,aAAa,mBAAmB,EAAE,WAAW,EAAE;AAC/C,aAAa,mBAAmB,EAAE,WAAW,EAAE;AAC/C,aAAa,mBAAmB,EAAE,WAAW,EAAE;AAC/C,aAAa,mBAAmB,EAAE,WAAW,EAAE;AAC/C,aAAa,mBAAmB,EAAE,WAAW,EAAE,0BAA0B,EAAE;AAC3E,aAAa,mBAAmB,EAAE,WAAW,EAAE,0BAA0B,EAAE;AAC3E,aAAa,mBAAmB,EAAE,WAAW,EAAE,0BAA0B,EAAE;AAC3E,aAAa,mBAAmB,EAAE,WAAW,EAAE,0BAA0B,EAAE;AAC3E,aAAa,mBAAmB,EAAE,WAAW,EAAE,0BAA0B,EAAE,2CAA2C,EAAE;;AAExH,iBAAiB;AACjB;IACI,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,4BAA4B;AAChC;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IAEZ,2BAA2B;IAC3B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,qDAAqD;IACrD,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,0BAA0B;AAC9B;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB","sourcesContent":["/* SimpleCRM Games — shared styles for the hub + individual games */\n\n.games-hero {\n    background: linear-gradient(135deg, #1F2937 0%, #111827 100%);\n    color: #fff;\n    border-radius: 14px;\n}\n\n.games-card {\n    transition: transform 0.15s ease, box-shadow 0.15s ease;\n    cursor: pointer;\n    background: #fff;\n    border: 1px solid #E5E7EB;\n    border-radius: 12px;\n}\n\n.games-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);\n}\n\n.games-card-icon {\n    height: 56px;\n    width: 56px;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 28px;\n    color: #fff;\n    flex-shrink: 0;\n}\n\n/* Pulse for online dot */\n@keyframes crm-pulse-dot {\n    0%   { box-shadow: 0 0 0 0   rgba(16, 185, 129, 0.55); }\n    70%  { box-shadow: 0 0 0 6px rgba(16, 185, 129, 0); }\n    100% { box-shadow: 0 0 0 0   rgba(16, 185, 129, 0); }\n}\n.crm-online-dot {\n    height: 8px;\n    width: 8px;\n    border-radius: 999px;\n    background: #10B981;\n    animation: crm-pulse-dot 2s infinite;\n    flex-shrink: 0;\n}\n\n/* 2048 tiles */\n.tile {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 10px;\n    font-weight: 700;\n    user-select: none;\n    transition: transform 80ms;\n}\n\n.tile-0    { background: #E5E7EB; color: transparent; }\n.tile-2    { background: #FDE68A; color: #78350F; }\n.tile-4    { background: #FCD34D; color: #78350F; }\n.tile-8    { background: #FB923C; color: #fff; }\n.tile-16   { background: #F97316; color: #fff; }\n.tile-32   { background: #EF4444; color: #fff; }\n.tile-64   { background: #DC2626; color: #fff; }\n.tile-128  { background: #FBBF24; color: #fff; font-size: 28px !important; }\n.tile-256  { background: #F59E0B; color: #fff; font-size: 28px !important; }\n.tile-512  { background: #D97706; color: #fff; font-size: 28px !important; }\n.tile-1024 { background: #B45309; color: #fff; font-size: 22px !important; }\n.tile-2048 { background: #92400E; color: #fff; font-size: 22px !important; box-shadow: 0 0 16px rgba(217, 119, 6, 0.6); }\n\n/* Memory cards */\n.memory-card {\n    perspective: 1000px;\n    aspect-ratio: 1;\n    cursor: pointer;\n}\n.memory-card-inner {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    transition: transform 0.5s;\n    transform-style: preserve-3d;\n}\n.memory-card.flipped .memory-card-inner {\n    transform: rotateY(180deg);\n}\n.memory-card-face {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 28px;\n}\n.memory-card-face.front {\n    background: linear-gradient(135deg, #6366F1, #4F46E5);\n    color: #fff;\n}\n.memory-card-face.back {\n    background: #fff;\n    border: 2px solid #E5E7EB;\n    transform: rotateY(180deg);\n}\n.memory-card.matched .memory-card-face.back {\n    background: #D1FAE5;\n    border-color: #10B981;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
